import Vue from 'vue';
import { mapGetters } from 'vuex';
import HMDialog from '@/web/components/common/HMDialog.vue';

const DirtyMixin = Vue.extend({
  computed: {
    ...mapGetters({
      isDirty: 'globals/isDirty',
    }),
  },
  methods: {
    setDirty(): void {
      this.$store.dispatch('globals/setDirty', true);
    },
    clearDirty(): void {
      this.$store.dispatch('globals/setDirty', false);
    },
    beforeWindowUnload(e) {
      if (this.isDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      this.$modal.show(HMDialog, {
        title: this.$t('GENERAL.TITLE.DISCARD_CHANGES'),
        subtitle: this.$t('GENERAL.TEXT.DO_YOU_REALLY_WANT_TO_DO_IT'),
        text: this.$t('GENERAL.TEXT.UNSAVED_CHANGES_WILL_BE_LOST'),
        confirmButton: this.$t('GENERAL.BUTTON.STAY_ON_PAGE'),
        discardButton: this.$t('GENERAL.BUTTON.LEAVE'),
        confirm: () => {
          next(false);
        },
        discard: () => {
          this.clearDirty();
          next();
        },
      });
    } else {
      next();
    }
  },
});
export default DirtyMixin;
